import { render } from "./WebinarInstructor.vue?vue&type=template&id=6deee6d9"
import script from "./WebinarInstructor.vue?vue&type=script&lang=js"
export * from "./WebinarInstructor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__